import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const ServiciosPage = () => {
  const [activeService, setActiveService] = useState(0);

  const services = [
    {
      id: 1,
      title: "Diagnóstico Automotriz Avanzado",
      subtitle: "Tecnología de última generación",
      description: "Utilizamos equipos de diagnóstico de última generación para identificar problemas en sistemas electrónicos, motor, transmisión y más.",
      image: "https://public.readdy.ai/ai/img_res/2c700817c13f361577115d2228f180d5.jpg",
      features: [
        "Scanner profesional multimarca",
        "Diagnóstico de motor y transmisión",
        "Análisis de sistemas electrónicos",
        "Reporte detallado de fallas",
        "Cotización sin compromiso"
      ],
      price: "Consultar precio",
      duration: "30-60 minutos"
    },
    {
      id: 2,
      title: "Programación de Módulos ECU",
      subtitle: "Especialistas en electrónica vehicular",
      description: "Programación y reparación de módulos de control electrónico (ECU) para todas las marcas de vehículos.",
      image: "https://readdy.ai/api/search-image?query=ECU%20programming%20service%2C%20automotive%20technician%20programming%20car%20computer%20module%2C%20electronic%20control%20unit%20repair%2C%20professional%20automotive%20electronics%20workshop%2C%20modern%20diagnostic%20equipment&width=600&height=400&seq=service2&orientation=landscape",
      features: [
        "Programación ECU multimarca",
        "Reparación de módulos dañados",
        "Actualización de software",
        "Clonado de módulos",
        "Garantía de 6 meses"
      ],
      price: "Consultar precio",
      duration: "2-4 horas"
    },
    {
      id: 3,
      title: "Llaves Inteligentes y Sistemas Keyless",
      subtitle: "Soluciones en cerrajería automotriz",
      description: "Programación, reparación y duplicado de llaves inteligentes, controles remotos y sistemas de acceso sin llave.",
      image: "https://readdy.ai/api/search-image?query=Smart%20car%20key%20programming%20service%2C%20automotive%20locksmith%20programming%20intelligent%20car%20keys%2C%20key%20cutting%20and%20programming%20equipment%2C%20professional%20automotive%20key%20service&width=600&height=400&seq=service3&orientation=landscape",
      features: [
        "Programación de llaves con chip",
        "Sistemas keyless entry",
        "Controles remotos",
        "Llaves de emergencia",
        "Servicio especializado"
      ],
      price: "Consultar precio",
      duration: "45-90 minutos"
    },
    {
      id: 4,
      title: "Mantenimiento Predictivo B2B",
      subtitle: "Soluciones empresariales especializadas",
      description: "Servicios B2B especializados para empresas con vehículos, incluyendo mantenimiento predictivo, gestión integral y soporte técnico dedicado.",
      image: "https://readdy.ai/api/search-image?query=Fleet%20maintenance%20service%2C%20commercial%20vehicles%20in%20professional%20automotive%20service%20center%2C%20truck%20and%20van%20maintenance%2C%20fleet%20management%20diagnostic%20equipment%2C%20industrial%20automotive%20repair%20facility&width=600&height=400&seq=service4&orientation=landscape",
      features: [
        "Diagnóstico preventivo especializado",
        "Gestión integral de mantenimiento",
        "Reportes detallados y análisis",
        "Planes personalizados B2B",
        "Soporte técnico empresarial 24/7"
      ],
      price: "Consultar",
      duration: "Según plan empresarial"
    }
  ];

  const processSteps = [
    {
      step: "01",
      title: "Recepción del Vehículo",
      description: "Recibimos tu vehículo y realizamos una inspección inicial para entender el problema."
    },
    {
      step: "02",
      title: "Diagnóstico Profesional",
      description: "Utilizamos equipos especializados para realizar un diagnóstico completo y preciso."
    },
    {
      step: "03",
      title: "Reparación Especializada",
      description: "Nuestros técnicos certificados realizan la reparación con garantía de calidad."
    },
    {
      step: "04",
      title: "Pruebas y Entrega",
      description: "Realizamos pruebas exhaustivas y te entregamos tu vehículo funcionando perfectamente."
    }
  ];

  useEffect(() => {
    // Add structured data for services page
    const structuredData = [
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Servicios Automotrices - Mechatronicx SAS",
        "description": "Soluciones integrales en electrónica automotriz con tecnología de vanguardia",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/servicios`,
        "mainEntity": {
          "@type": "Service",
          "name": "Servicios de Electrónica Automotriz",
          "provider": {
            "@type": "Organization",
            "name": "Mechatronicx SAS"
          },
          "serviceType": "Diagnóstico y Reparación Automotriz"
        }
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "¿Cuánto tiempo toma el diagnóstico de mi vehículo?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "El diagnóstico básico toma entre 30-60 minutos. Para casos más complejos puede extenderse hasta 2 horas. Te informamos el tiempo estimado al recibir tu vehículo."
            }
          },
          {
            "@type": "Question",
            "name": "¿Ofrecen garantía en las reparaciones?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "La garantía depende del producto y del vehículo. Si vendemos nosotros el producto y lo instalamos, claramente tiene garantía. Consulta los términos específicos para tu caso."
            }
          },
          {
            "@type": "Question",
            "name": "¿Pueden programar llaves para cualquier marca de vehículo?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Sí, trabajamos con todas las marcas de vehículos incluyendo Chevrolet, Ford, Renault, Nissan, Toyota, Hyundai, Kia, Mazda, Volkswagen y muchas más. Tenemos servicios especializados para cada marca."
            }
          }
        ]
      }
    ];

    const scripts = [];
    structuredData.forEach(data => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(data);
      document.head.appendChild(script);
      scripts.push(script);
    });

    return () => {
      scripts.forEach(script => {
        if (document.head.contains(script)) {
          document.head.removeChild(script);
        }
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-lg fixed w-full top-0 z-50">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-3 cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/db14669796bfd9c6751821edba8bd22a.png" 
                alt="Mechatronicx Logo" 
                className="h-12 w-auto"
              />
              <div>
                <h1 className="text-xl font-bold text-gray-900">MECHATRONICX</h1>
                <p className="text-xs text-gray-600">Soluciones Electrónicas Automotrices</p>
              </div>
            </Link>
            <nav className="hidden lg:flex items-center space-x-6 xl:space-x-8">
              <Link to="/" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Inicio</Link>
              <Link to="/servicios" className="text-red-600 font-semibold cursor-pointer">Servicios</Link>
              <Link to="/productos" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Productos</Link>
              <Link to="/empresas" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Empresas</Link>
              <Link to="/blog" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Blog</Link>
              <a 
                href="https://wa.me/573202047129"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-red-600 text-white px-4 xl:px-6 py-2 rounded-full hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer text-sm xl:text-base"
              >
                Cotizar Ahora
              </a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative h-96 overflow-hidden mt-20">
        <div className="absolute inset-0">
          <img 
            src="https://readdy.ai/api/search-image?query=Modern%20automotive%20service%20center%20with%20professional%20diagnostic%20equipment%2C%20clean%20workshop%20environment%20with%20cars%20being%20serviced%2C%20automotive%20technicians%20working%20with%20electronic%20diagnostic%20tools%2C%20professional%20automotive%20repair%20facility&width=1200&height=400&seq=serviceshero&orientation=landscape"
            alt="Servicios Automotrices"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/60"></div>
        </div>
        
        <div className="relative z-10 container mx-auto px-4 h-full flex items-center">
          <div className="text-white max-w-3xl">
            <h1 className="text-5xl font-bold mb-4">Servicios Especializados</h1>
            <p className="text-xl mb-6">
              Soluciones integrales en electrónica automotriz con tecnología de vanguardia y personal certificado
            </p>
            <button className="bg-red-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-red-700 transform hover:scale-105 transition-all whitespace-nowrap cursor-pointer">
              Agendar Cita
            </button>
          </div>
        </div>
      </section>

      {/* Services Detail Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Nuestros Servicios</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Cada servicio está diseñado para brindar soluciones efectivas y duraderas
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <div className="space-y-4">
                {services.map((service, index) => (
                  <div 
                    key={service.id}
                    onClick={() => setActiveService(index)}
                    className={`p-6 rounded-xl cursor-pointer transition-all ${
                      activeService === index 
                        ? 'bg-red-50 border-2 border-red-200' 
                        : 'bg-gray-50 hover:bg-gray-100'
                    }`}
                  >
                    <div className="flex items-center justify-between">
                      <div>
                        <h3 className={`text-lg font-bold ${
                          activeService === index ? 'text-red-600' : 'text-gray-900'
                        }`}>
                          {service.title}
                        </h3>
                        <p className="text-gray-600 text-sm">{service.subtitle}</p>
                      </div>
                      <i className={`ri-arrow-right-line text-xl ${
                        activeService === index ? 'text-red-600' : 'text-gray-400'
                      }`}></i>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
              <img 
                src={services[activeService].image}
                alt={services[activeService].title}
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  {services[activeService].title}
                </h3>
                <p className="text-gray-600 mb-6">
                  {services[activeService].description}
                </p>
                
                <div className="grid md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-3">Incluye:</h4>
                    <ul className="space-y-2">
                      {services[activeService].features.map((feature, idx) => (
                        <li key={idx} className="flex items-center text-sm text-gray-700">
                          <i className="ri-check-line text-green-500 mr-2"></i>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                  
                  <div>
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <div className="flex items-center justify-between">
                        <span className="text-gray-600">Duración:</span>
                        <span className="font-semibold">{services[activeService].duration}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <a 
                  href="https://wa.me/573202047129"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-red-600 text-white py-3 rounded-full font-semibold hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer inline-block text-center"
                >
                  Solicitar Este Servicio
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Nuestro Proceso</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Un proceso estructurado que garantiza la mejor atención y resultados
            </p>
          </div>

          <div className="grid md:grid-cols-5 gap-8 max-w-6xl mx-auto">
            {processSteps.map((step, index) => (
              <div key={index} className="text-center">
                <div className="relative mb-6">
                  <div className="w-16 h-16 bg-red-600 text-white rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-4">
                    {step.step}
                  </div>
                  {index < processSteps.length - 1 && (
                    <div className="hidden md:block absolute top-8 left-full w-full h-0.5 bg-red-200 transform -translate-y-1/2"></div>
                  )}
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-gray-600 text-sm">{step.description}</p>
              </div>
            ))}
            
            {/* Quinto paso adicional */}
            <div className="text-center">
              <div className="relative mb-6">
                <div className="w-16 h-16 bg-red-600 text-white rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-4">
                  05
                </div>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Seguimiento Post-Servicio</h3>
              <p className="text-gray-600 text-sm">Te contactamos para verificar que todo funcione correctamente y resolver cualquier duda.</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Preguntas Frecuentes</h2>
            <p className="text-xl text-gray-600">Resolvemos las dudas más comunes sobre nuestros servicios</p>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="space-y-6">
              {[
                {
                  question: "¿Cuánto tiempo toma el diagnóstico de mi vehículo?",
                  answer: "El diagnóstico básico toma entre 30-60 minutos. Para casos más complejos puede extenderse hasta 2 horas. Te informamos el tiempo estimado al recibir tu vehículo."
                },
                {
                  question: "¿Ofrecen garantía en las reparaciones?",
                  answer: "La garantía depende del producto y del vehículo. Si vendemos nosotros el producto y lo instalamos, claramente tiene garantía. Consulta los términos específicos para tu caso."
                },
                {
                  question: "¿Pueden programar llaves para cualquier marca de vehículo?",
                  answer: "Sí, trabajamos con todas las marcas de vehículos incluyendo Chevrolet, Ford, Renault, Nissan, Toyota, Hyundai, Kia, Mazda, Volkswagen y muchas más. Tenemos servicios especializados para cada marca."
                },
                {
                  question: "¿Realizan servicios a domicilio?",
                  answer: "No realizamos servicios a domicilio, pero contamos con servicio de grúa que puede recoger su vehículo y traerlo a nuestro taller en Bogotá. Consulta disponibilidad y costos del servicio de grúa."
                },
                {
                  question: "¿Qué formas de pago aceptan?",
                  answer: "Aceptamos múltiples formas de pago: efectivo, tarjetas de débito y crédito, Nequi, Daviplata, transferencias bancarias y otros medios de pago electrónicos."
                }
              ].map((faq, index) => (
                <div key={index} className="bg-white rounded-lg shadow-md p-6">
                  <h3 className="text-lg font-bold text-gray-900 mb-3">{faq.question}</h3>
                  <p className="text-gray-600">{faq.answer}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-gray-900 to-red-900 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">¿Listo para Solucionar tu Problema?</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Nuestro equipo de expertos está preparado para brindarte la mejor solución. 
            Agenda tu cita hoy mismo y experimenta la diferencia.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://wa.me/573202047129"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-red-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-red-700 transform hover:scale-105 transition-all whitespace-nowrap cursor-pointer inline-block text-center"
            >
              Agendar Cita Ahora
            </a>
            <a 
              href="tel:+573202047129"
              className="border-2 border-white text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white hover:text-gray-900 transition-all whitespace-nowrap cursor-pointer inline-block text-center"
            >
              Llamar: 320 204 7129
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center space-x-3 mb-6">
                <img 
                  src="https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/db14669796bfd9c6751821edba8bd22a.png" 
                  alt="Mechatronicx Logo" 
                  className="h-10 w-auto"
                />
                <div>
                  <h3 className="text-lg font-bold">MECHATRONICX</h3>
                  <p className="text-xs text-gray-400">Soluciones Electrónicas</p>
                </div>
              </div>
              <p className="text-gray-400 mb-4">
                Servicios especializados en electrónica automotriz con garantía de calidad.
              </p>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-6">Servicios</h4>
              <ul className="space-y-3">
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Diagnóstico Automotriz</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Programación ECU</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Llaves Inteligentes</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Mantenimiento Flotas</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-6">Contacto</h4>
              <div className="space-y-3">
                <div className="flex items-center">
                  <i className="ri-map-pin-line text-red-500 mr-3"></i>
                  <span className="text-gray-400">Ave Cra 30 #29-09 Sur, Bogotá DC</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-phone-line text-red-500 mr-3"></i>
                  <span className="text-gray-400">320 204 7129</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-mail-line text-red-500 mr-3"></i>
                  <span className="text-gray-400">Gerencia@mechatronicxsas.com</span>
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-6">Horarios</h4>
              <div className="space-y-3 text-gray-400">
                <div>
                  <p className="font-semibold">Lunes - Viernes</p>
                  <p>8:00am - 5:30pm</p>
                </div>
                <div>
                  <p className="font-semibold">Sábado</p>
                  <p>8:00am - 2:00pm</p>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-12 pt-8 text-center">
            <p className="text-gray-400">
              © 2024 Mechatronicx SAS. Todos los derechos reservados. | 
              <a href="https://maiketing.agency" target="_blank" rel="noopener noreferrer" className="text-red-500 hover:text-red-400 ml-1 cursor-pointer">
                Powered by MAIketing.agency
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ServiciosPage;
